import type { AiModelId } from "./types";

export const DEFAULT_AI_MODEL: AiModelId = "deepseek-v4-flash";

export const AI_MODEL_OPTIONS: Array<{
  id: AiModelId;
  name: string;
  positioning: string;
  bestFor: string;
  inputPrice: number;
  outputPrice: number;
  concurrency: number;
}> = [
  {
    id: "deepseek-v4-flash",
    name: "DeepSeek V4 Flash",
    positioning: "日常高频研究",
    bestFor: "晨会摘要、材料初筛、宏观快照和常规研究问答",
    inputPrice: 1,
    outputPrice: 2,
    concurrency: 2500,
  },
  {
    id: "deepseek-v4-pro",
    name: "DeepSeek V4 Pro",
    positioning: "复杂深度判断",
    bestFor: "基金尽调、公司与行业深研、投委会交叉质询和复杂 RAG 综合",
    inputPrice: 3,
    outputPrice: 6,
    concurrency: 500,
  },
];

export function isAiModelId(value: unknown): value is AiModelId {
  return value === "deepseek-v4-flash" || value === "deepseek-v4-pro";
}

export function normalizeAiModel(value: unknown, fallback: AiModelId = DEFAULT_AI_MODEL): AiModelId {
  return isAiModelId(value) ? value : fallback;
}
